import z from 'zod'
import { LeaveRequestSource } from '../enums/LeaveRequestSource.enum'
import { AccountTeam } from '../enums/AccountTeam.enum'
import { LeaveTime } from '../enums/LeaveTime.enum'
import { LeaveType } from '../enums/LeaveType.enum'
import ZodHelper from '../../helpers/zod.helper'

const leaveRequestEditSchema = z
  .object({
    source: ZodHelper.zEnumFromTsEnum(LeaveRequestSource).optional(),
    name: z.string().min(2).optional(),
    email: z.email().optional(),
    accountTeam: ZodHelper.zEnumFromTsEnum(AccountTeam).optional(),
    position: z.string().min(2).optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    leaveTime: ZodHelper.zEnumFromTsEnum(LeaveTime).optional(),
    leaveType: ZodHelper.zEnumFromTsEnum(LeaveType).optional(),
    otherLeaveType: z.string().nullish().optional(),
    reason: z.string().nullish().optional(),
  })
  .refine(
    data => {
      if (data.leaveType === LeaveType.OTHER && (!data.otherLeaveType || data.otherLeaveType.length < 2)) return false
      return true
    },
    {
      message: 'Please enter other leave type...',
      path: ['otherLeaveType'],
    },
  )

export type LeaveRequestEditSchema = z.infer<typeof leaveRequestEditSchema>

export default leaveRequestEditSchema
